/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedContactDealerWrapper_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespHeroCarouselRequestMoreImages_user$ref: FragmentReference;
export type PdpRespHeroCarouselRequestMoreImages_user = {|
  +serviceId: ?string,
  +$fragmentRefs: SharedContactDealerWrapper_user$ref,
  +$refType: PdpRespHeroCarouselRequestMoreImages_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselRequestMoreImages_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1312d899977bc0e275bac12dd2af63cc';
module.exports = node;
